// @flow
import * as React from "react";
import { Modal } from "react-bootstrap";

import { translate } from "../IntlProviderWrapper";
import ErrorComponent, { type ErrorType } from "../ErrorComponent";

type Props = {
    show: boolean,
    title: string,
    label: string,
    value?: string,
    error?: string,
    error_type?: ErrorType,
    type?: "text" | "number",
    isValid: (value: string) => boolean,
    onAccept: (value: string) => Promise<void>,
    onCancel: () => void,
};

type State = {
    value: string,
    error: string,
};

class TextInputModal extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            value: "",
            error: "",
        };
    }

    componentDidMount() {
        this.initValue();
    }

    componentDidUpdate(prev_props: Props) {
        if (this.props.value !== prev_props.value || (this.props.show !== prev_props.show && this.props.show)) {
            this.initValue();
        }
    }

    initValue = () => {
        const value = this.props.value || "";
        this.setState({
            value,
        });
        this.validate(value);
    };

    validate = (value: string) => {
        let error = "";
        if (!this.props.isValid(value) && this.props.error !== undefined) {
            error = this.props.error;
        }

        this.setState({
            error,
        });
    };

    handleSubmit = (event: SyntheticEvent<HTMLFormElement>) => {
        event.preventDefault();
        const form_data = new FormData(event.currentTarget);
        const value = form_data.get("value");
        if (value && typeof value === "string") {
            this.setState({
                error: "",
            });
            this.props.onAccept(value);
        }
    };

    handleValueChange = (event: SyntheticEvent<HTMLInputElement>) => {
        const value = event.currentTarget.value;
        this.setState({
            value: value,
            error: "",
        });
        this.validate(value);
    };

    handleClose = () => {
        this.props.onCancel();
        this.setState({
            value: "",
            error: "",
        });
    };

    render() {
        return (
            <Modal show={this.props.show} onHide={this.handleClose} animation={false}>
                <Modal.Header>
                    <Modal.Title>{this.props.title}</Modal.Title>
                    <button type="button" className="close" onClick={this.handleClose}>
                        <span aria-hidden="true">×</span>
                        <span className="sr-only">{translate("common.close", "Close")}</span>
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <form id="text-input-form" onSubmit={this.handleSubmit}>
                        <div className="form-group mb-0">
                            <label htmlFor="text-input">{this.props.label}</label>
                            <input
                                id="text-input"
                                className="form-control"
                                type={this.props.type || "text"}
                                name="value"
                                value={this.state.value}
                                onChange={this.handleValueChange}
                                autoFocus
                            />
                        </div>
                        {this.state.error && (
                            <ErrorComponent
                                className="mb-0"
                                type={this.props.error_type || "warning"}
                                msg={this.state.error}
                            />
                        )}
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        className="btn btn-primary"
                        type="submit"
                        form="text-input-form"
                        disabled={!this.state.value}
                    >
                        {translate("common.ok", "OK")}
                    </button>
                    <button className="btn btn-outline-secondary" onClick={this.handleClose}>
                        {translate("common.cancel", "cancel")}
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default TextInputModal;
